import { Module, VuexModule, Mutation } from "vuex-module-decorators";
import { stationStatusValues, stationLevelValues, stationTypeValues } from "@/classes/station";
import { utilityValues } from "@/classes/property";

@Module({
  namespaced: true,
  name: "Organizations"
})
export default class Organizations extends VuexModule {
  advancedSearchOpen = false;
  filterByStationStatusSelected: typeof stationStatusValues[0] | "ALL" = "ALL";
  filterByStationTypeSelected: typeof stationTypeValues[0] | "ALL" = "ALL";
  filterByStationLevelSelected: typeof stationLevelValues[0] | "ALL" = "ALL";
  filterByUtilitySelected: typeof utilityValues[0] | "ALL" = "ALL";
  filterByFundingSelected: string | "ALL" = "ALL";
  filterByToggleEnabled = "ALL";
  filterByToggleSubscription = "ALL";
  filterByToggleGateway = "ALL";
  selectedItemId: string | null = null;
  reportingConfigYAxisDisconnects = "Disconnects";
  reportingConfigYAxis1 = "Charge Sessions";
  reportingConfigYAxis2 = "Energy Consumed kWh";
  reportingConfigDateRangeOption = "Today";
  reportingFromDate: Date | null = null;
  reportingToDate: Date | null = null;
  search = "";
  detailsTabOpen = true;
  historyTabOpen = false;
  pricingTabOpen = false;
  pricingHistoryTabOpen = false;
  eventHistoryTabOpen = false;
  transactionHistoryTabOpen = false;
  touTransactionHistoryTabOpen = false;
  reportingTabOpen = false;
  stationTransactionHistoryTabOpen = false;
  stationConfigTabOpen = false;
  stationDisconnectHistoryTabOpen = false;
  disconnectReportingTabOpen = false;

  @Mutation
  setAdvancedSearchOpen(val: boolean) {
    this.advancedSearchOpen = val;
  }

  @Mutation
  setFilterByStationStatusSelected(val: Organizations["filterByStationStatusSelected"]) {
    this.filterByStationStatusSelected = val;
  }

  @Mutation
  setFilterByStationLevelSelected(val: Organizations["filterByStationLevelSelected"]) {
    this.filterByStationLevelSelected = val;
  }

  @Mutation
  setFilterByStationTypeSelected(val: Organizations["filterByStationTypeSelected"]) {
    this.filterByStationTypeSelected = val;
  }

  @Mutation
  setFilterByUtilitySelected(val: Organizations["filterByUtilitySelected"]) {
    this.filterByUtilitySelected = val;
  }

  @Mutation
  setFilterByFundingSelected(val: Organizations["filterByFundingSelected"]) {
    this.filterByFundingSelected = val;
  }

  @Mutation
  setFilterByToggleEnabled(val: Organizations["filterByToggleEnabled"]) {
    this.filterByToggleEnabled = val;
  }

  @Mutation
  setFilterByToggleSubscription(val: Organizations["filterByToggleSubscription"]) {
    this.filterByToggleSubscription = val;
  }

  @Mutation
  setFilterByToggleGateway(val: Organizations["filterByToggleGateway"]) {
    this.filterByToggleGateway = val;
  }

  @Mutation
  setReportingFromDate(date: Date | null) {
    this.reportingFromDate = date;
  }

  @Mutation
  setReportingToDate(date: Date | null) {
    this.reportingToDate = date;
  }

  @Mutation
  setDetailsTabOpen(data: Organizations["detailsTabOpen"]) {
    this.detailsTabOpen = data;
  }

  @Mutation
  setHistoryTabOpen(data: Organizations["historyTabOpen"]) {
    this.historyTabOpen = data;
  }

  @Mutation
  setPricingTabOpen(data: Organizations["pricingTabOpen"]) {
    this.pricingTabOpen = data;
  }

  @Mutation
  setPricingHistoryTabOpen(data: Organizations["pricingHistoryTabOpen"]) {
    this.pricingHistoryTabOpen = data;
  }

  @Mutation
  setEventHistoryTabOpen(data: Organizations["eventHistoryTabOpen"]) {
    this.eventHistoryTabOpen = data;
  }

  @Mutation
  setTransactionHistoryTabOpen(data: Organizations["transactionHistoryTabOpen"]) {
    this.transactionHistoryTabOpen = data;
  }

  @Mutation
  setTOUTransactionHistoryTabOpen(data: Organizations["touTransactionHistoryTabOpen"]) {
    this.touTransactionHistoryTabOpen = data;
  }

  @Mutation
  setReportingTabOpen(data: Organizations["reportingTabOpen"]) {
    this.reportingTabOpen = data;
  }

  @Mutation
  setDisconnectReportingTabOpen(data: Organizations["disconnectReportingTabOpen"]) {
    this.disconnectReportingTabOpen = data;
  }

  @Mutation
  setStationTransactionHistoryTabOpen(data: Organizations["stationTransactionHistoryTabOpen"]) {
    this.stationTransactionHistoryTabOpen = data;
  }

  @Mutation
  setSelectedItemId(data: Organizations["selectedItemId"]) {
    this.selectedItemId = data;
  }

  @Mutation
  setReportingConfigYAxis1(data: Organizations["reportingConfigYAxis1"]) {
    this.reportingConfigYAxis1 = data;
  }

  @Mutation
  setReportingConfigYAxis2(data: Organizations["reportingConfigYAxis2"]) {
    this.reportingConfigYAxis2 = data;
  }

  @Mutation
  setReportingConfigYAxisDisconnects(data: Organizations["reportingConfigYAxisDisconnects"]) {
    this.reportingConfigYAxisDisconnects = data;
  }

  @Mutation
  setReportingConfigQuickRange(data: Organizations["reportingConfigDateRangeOption"]) {
    this.reportingConfigDateRangeOption = data;
  }

  @Mutation
  setSearch(data: Organizations["search"]) {
    this.search = data;
  }

  @Mutation
  setStationConfigTabOpen(data: boolean) {
    this.stationConfigTabOpen = data;
  }

  @Mutation
  setStationDisconnectHistoryTabOpen(data: boolean) {
    this.stationDisconnectHistoryTabOpen = data;
  }
}
